/** 根据 appid 选择下载弹窗模板 */
// 这个后续再合并到utils中
export function getDownloadPopupTemplateType() {
  const templateType = Number(JSON.parse(localStorage.getItem('localConfig')).templateType)

  if (templateType == 'win2') {
    return 'Index52000'
  }

  return 'Index50000'
}

/** 弹窗 logo */
export const downloadPopupLogoUrl = '/theme/logo/logo.png'
